export const register = {
    lang: {
        en: 'Bahasa Inggeris',
        my: 'Bahasa Melayu',
        ch: 'Bahasa Cina'
    },
    title: 'Daftar',
    type: {
        name: 'Jenis ID',
        placeholder: 'Jenis ID',
        required: 'Jenis ID',
        too_short: '',
        invalid: '',
        defaultText: 'Jenis ID',
    },
    id_type: [
        { text:"Kad Pengenalan", value: "NRIC" },
        { text:"Pasport", value: "Passport" },
        { text:"ID Tentera", value: "Army ID" },
        { text:"ID Polis", value: "Police ID" },
    ],
    firstname: {
        name: 'Name seperti dalam ',
        placeholder: '',
        required: 'Name seperti dalam',
        too_short: '',
        invalid: '',
    },
    no: {
        name: ' Nombor',
        placeholder: ' Nombor',
        required: ' Nombor',
        too_short: '',
        invalid: '',
    },
    title_gender: 'Jantina',
    gender_list: [
        {
            text: 'Lelaki',
            value: 'Lelaki',
        },
        {
            text: 'Perempuan',
            value: 'Perempuan',
        },
    ],
    male: "Lelaki",
    female: "Perempuan",
    race: {
        name: 'Bangsa',
        placeholder: 'Bangsa',
        required: 'Bangsa',
        too_short: '',
        invalid: '',
    },
    flag: [
        { text:"malaysia", value: 0 },
        { text:"singapore", value: 1 },
    ],
    contactNumber: {
        name: 'Nombor Telefon Bimbit',
        placeholder: 'Nombor Telefon Bimbit',
        required: '',
        too_short: '',
        invalid: '',
    },
    email: {
        name: 'E-Mel',
        placeholder: 'E-Mel',
        required: '',
        too_short: '',
        invalid: '',
    },
    password: {
        name: 'Kata Laluan',
        placeholder: 'Kata Laluan',
        required: '',
        too_short: '',
        invalid: '',
    },
    confirm_password: {
        name: 'Pengesahan Kata Laluan',
        placeholder: 'Pengesahan Kata Laluan',
        required: '',
        too_short: '',
        invalid: '',
        match: '',
    },
    text_refer: 'Kawan Rujukan (Pilihan)',
    refer_friend: {
        name: 'Kod Rujukan',
        placeholder: 'Kod Rujukan',
        required: '',
        too_short: '',
        invalid: '',
    },
    select_img: 'select image',
    pdpa: {
        agree: 'Saya telah baca dan bersetuju dengan',
        terms: ' Terma & Syarat ',
        and: 'dan',
        privacy: ' Dasar Privasi'

    },
    btn: 'Seterusnya',
    birthdate: {
        name: 'วันเกิด',
        placeholder: 'วันเกิด',
        required: '',
        too_short: '',
        invalid: '',
    },
    otp_title: "Sila masukkan nombor OTP",
    otp_send_to: "Nombor OTP telah dihantar ke ",
    otp_refcode: "Kod Ref : ",
    resend_otp: "Nombor OTP akan dihantar semula dalam masa ",
    send_otp_again: "OTP akan dihantar semula",
    verify: "Sahkan",
    invalid_code: "Nombor OTP yang dimasukkan tidak sah. Sila cuba lagi atau hubungi khidmat pelanggan BHPetrol 03-7719 9499",
    error_code: "Kod Salah : ",
    modal_success_title: "Berjaya Didaftarkan",
    modal_success_subtitle: "Anda boleh log masuk Aplikasi eCard menggunakan nombor telefon bimbit yang telah didaftarkan sebentar tadi.",
    download_app: "Muat turun Aplikasi eCard",

    validate: {
        input_id: 'Nombor {0} yang dimasukkan tidak sah. Sila masukkan Nombor {1} yang betul.',
        input_invalid: '{0} yang dimasukkan tidak sah. Sila cuba lagi.',
        password: 'Kata laluan anda mestilah sekurang-kurangnya 6 abjad dan tidak lebih daripada 16 abjad. Kata laluan anda tidak boleh mengandungi ruang atau abjad istimewa. Contoh: Bhp123.',
        not_match: 'Kata Laluan dan Pengesahan Kata Laluan anda tidak sepadan. Sila masukkan semula.',
        btn: 'Tutup'
    },
    valid_mobile: 'Nombor Telefon Bimbit',
    valid_email: 'E-mel',

    error: {
        title: "Ralat",
        err_id: {
            msg: "ID telah didaftar. Sila hubungi Pusat Khidmat Pelanggan BHPetrol untuk bantuan selanjutnya di 03-7719 9499."
        },
        err_number: {
            msg: "Nombor Telefon telah didaftar. Sila hubungi Pusat Khidmat Pelanggan BHPetrol untuk bantuan selanjutnya di 03-7719 9499."
        },
        err_dup_email: {
            msg: " E-mel telah didaftar. Sila hubungi Pusat Khidmat Pelanggan BHPetrol untuk bantuan selanjutnya di 03-7719 9499."
        },
        err_refcode_full: {
            msg: "Had kod rujukan telah dicapai."
        },
        err_invalid_refcode: {
            msg: "Kod rujukan tidak sah."
        },
    },
    register_error_title: "Ralat",
    register_error_msg: "Description: Register unsuccessful. Please call BHPetrol Customer Service Centre for assistance at 03-7719 9499",
}
